export const INIT_UI = 'fulcrum/containers/DesktopSchedule/INIT_SCHEDULE'
export const INPUT_CHANGE = 'fulcrum/containers/DesktopSchedule/INPUT_CHANGE'
export const DATE_CHANGE = 'fulcrum/containers/DesktopSchedule/DATE_CHANGE'
export const INPUT_UI_CHANGE = 'fulcrum/containers/DesktopSchedule/INPUT_UI_CHANGE'
